import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useRequestRefundMutation = createMutationHook(
  MembershipsCreatorApiClient.requestRefund,
  {
    mutationKey: ['requestRefund'],
  },
)
